import { useHistory, useParams } from 'react-router-dom'
import { format } from 'date-fns'
import { BackLink } from 'src/components/common'
import { useAuth } from 'src/contexts/auth.context'
import { useNotification } from 'src/contexts/notification.context'
import {
  createTeacherEvent,
  createStudentEvent,
  createTeacherClassroomEvent,
} from 'src/services/api.service'
import { routes } from 'src/navigation/routes'
import ScheduleForm from './form'

export const NewSchedule = () => {
  const { user } = useAuth()
  const { date = null } = useParams()
  const { wrapCallback } = useNotification()
  const history = useHistory()

  const initialValues = {
    color: '1',
    priority: 'regular',
    title: '',
    content: '',
    note: '',

    started_at: date ? new Date(date) : new Date(),
    finished_at: date ? new Date(date) : new Date(),

    classroom_id: null,
    user_id: null,

    recurrence_type: 1,
  }

  const onSubmit = async (values) => {
    wrapCallback(async () => {
      const { classroom_id, user_id, started_at, finished_at, ...rest } = values

      const start_date = format(started_at, 'yyyy-MM-dd')
      const start_time = format(started_at, 'HH:mm')
      const end_date = format(finished_at, 'yyyy-MM-dd')
      const end_time = format(finished_at, 'HH:mm')

      const data = {
        ...rest,
        start_date,
        start_time,
        end_date,
        end_time,
      }

      if (classroom_id && !user_id) {
        await createTeacherClassroomEvent({ ...data, classroom_id })
      } else {
        const createEvent =
          user.role_id === 1 ? createTeacherEvent : createStudentEvent
        await createEvent({
          ...data,
          user_id: user_id ? Number(user_id) : undefined,
        })
      }

      history.replace(routes.timetable.day(date))
    })
  }

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to={routes.timetable.day(date)} />
        <h2 className="sectionHb-title">New schedule</h2>
      </div>

      <div className="sectionHb-block purchaseHb">
        <div className="sectionHb-block__wrap">
          <ScheduleForm initialValues={initialValues} onSubmit={onSubmit} />
        </div>
      </div>
    </>
  )
}
